import { render } from "./DiagnosisDetail.vue?vue&type=template&id=dcffe3d2&scoped=true"
import script from "./DiagnosisDetail.vue?vue&type=script&lang=js"
export * from "./DiagnosisDetail.vue?vue&type=script&lang=js"

import "./DiagnosisDetail.vue?vue&type=style&index=0&id=dcffe3d2&lang=scss"
import "./DiagnosisDetail.vue?vue&type=style&index=1&id=dcffe3d2&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcffe3d2"]])

export default __exports__